<template>
  <a-modal
    :title="title"
    centered="true"
    :visible="visible"
    :confirm-loading="confirmLoading"
    footer=" "
    class="ab-modal"
    @cancel="handleCancel"
    width="43.2rem"
    :bodyStyle="{ padding: '0px' }"
  >
    <span slot="closeIcon">
      <a-icon type="close-circle" theme="filled" style="color: #fff" />
    </span>
    <!-- <div class="ab-modal-body"> -->
    <slot v-if="!errorMsgStatus"></slot>
    <div v-else style="height: calc(100vh - 200px);">
      <ab-error-vue></ab-error-vue>
    </div>
    <!-- </div> -->
  </a-modal>
</template>

<script>
import AbErrorVue from './AbError.vue';
export default {
  props: ['visible', 'title', 'errorMsgStatus'],
  components: {
    AbErrorVue,
  },
  data() {
    return {
      confirmLoading: false,
    };
  },

  methods: {
    handleCancel(e) {
      // this.visible = false;
      this.$emit('cancel');
    },
  },
};
</script>

<style lang="sass" scoped>
::v-deep .ant-pagination-item-active {
  a{
 color:#fff;
  }
    background: #198BFF;

    border-color: #198BFF;
}
.ab-modal{
  background: #2B68FF;
  .ab-modal-body{
    // min-height: 600px;
  }
}
::v-deep .ant-modal-close-x{
  &:hover{
    opacity: 1
  }
  font-size:35px;
   margin-top:12px;
   margin-right:15px;
  opacity: .7
}

::v-deep .ant-modal-content{
  border-radius: 30px 30px 20px 20px;
}
::v-deep .ant-list-pagination{

  margin-bottom:30px;
}
::v-deep .ant-modal-header{
    display: flex;
    flex-wrap: wrap;
    align-content: center;
  height: 80px;
  background: #2B68FF;
  border-radius: 20px 20px 0px 0px;
}
::v-deep .ant-modal-footer{
  border:none;
}
::v-deep .ant-modal-title{
    color: #ffffff;
     font-size:20px;
     margin-left:55px;

}
</style>
